const capStats = board => {
  board.confidence = Math.min(Math.max(Math.round(board.confidence), 1), 100)
}

export {
  capStats
}
